<template>
  <div class="landing-page" style="padding-top: 0;">
    <div class="login-content">
      <div class="login login-send">
        <div class="">
          <div class="" style="text-align: center">
            <img style="width: 35%;margin-top: 50px" src="../../static/images/logo.png">
          </div>
          <div class="middle">
            <img src="../../static/images/login_pic1.png">
          </div>
          <div class="login-overlay otp-form">
            <div class="otp-field">
              <div class="otp-label">{{ $t('phoneNumber') }}</div>
              <div class="otp-control otp-control--readonly">
                <input class="input" v-model="mobile" disabled aria-label="Phone number">
              </div>
            </div>

            <div class="otp-field">
              <div class="otp-label">OTP</div>
              <div class="otp-code-row">
                <div class="otp-control">
                  <input class="input" v-model="otp" ref="getFocus2" maxlength="6" type="tel" inputmode="numeric"
                         pattern="[0-9]*" @input="handleOtpInput" aria-label="OTP">
                </div>
                <button class="otp-send-button" :class="{ disable: codeText != $t('getCode') }" type="button"
                        :disabled="codeText != $t('getCode')" @click="getSendOtp">{{ codeText }}</button>
              </div>
            </div>

            <div class="login-list otp-login-list">
              <button class="drown-li otp-login-button" type="button" @click="goLogin">
                <span class="day day-en btn-text">{{ $t('Login') }}</span>
              </button>
            </div>
            <div class="ac por esim-row">
              <div class="esim-text">
                <span>{{ $t('need_esim_prefix') }}</span>
                <span class="esim-link" @click="goBuyESim">{{ $t('get_esim') }}</span>
              </div>
            </div>
          </div>
<!--          <div class="ac otp-b disflex por login-footer">
            <div class="icon icon2 login_help" @click="getChange('faq')">{{ $t('FAQs') }}</div>
          </div>-->
        </div>
      </div>
    </div>
  </div>
</template>
<script>

import CryptoJS from '../../static/js/crypto-js.min.js'

export default {
  components: {

  },
  data() {
    return {
      list: [],
      mobile: '',
      password: '',
      otp: '',
      codeText: '',
      isReturn: false,
      isEN: 'bur',
      channel: '',

    }
  },
  watch: {
    otp(now, old) {
      let that = this;
      that.$nextTick(function () {
        if (now.length == 4 || old == now) {
          that.timer = setTimeout(() => {
            that.$refs.getFocus2.blur();
          }, 100);
        }
      });
    },
  },
  created() {
    this.codeText = this.$t('getCode')
    this.mobile = sessionStorage.getItem('login_mobile') || '';
    if (this.mobile) {
      this.getSendOtp();
    }
    if(this.$route.query.channel){
      this.channel = this.$route.query.channel;
    }
    this.sendReport();
  },
  methods: {
    handleOtpInput(event) {
      this.otp = event.target.value.replace(/[^0-9]/g, '');
    },
    getType(type) {
      this.$router.push({path: '/' + type, query: {type: type}});
    },
    back() {
      this.$router.go(-1);
    },
    getSendOtp() {
      let that = this
      if (that.isReturn) {
        return;
      }
      if(that.mobile == '') {
        that.$utils.alertText(that.$t('loginTips'), 60)
        return;
      }
      that.isReturn = true
      let data = {
        'mobile': that.mobile
      }
      that.$parent.loadModal(true);
      that.$api.post('/api/user/login_send_otp', data, r => {
        that.isReturn = false
        that.$parent.loadModal(false);
        that.$utils.alertText(r.msg, 80, 3000);
        if (r.code == 1) {
          this.countDown(301, 1)
        }
      })
    },
    goLogin() {
      let that = this
      if (that.mobile == '') {
        that.$utils.alertText(that.$t('loginTips'), 60)
        return;
      }
      if (that.otp == '') {
        that.$utils.alertText(that.$t('otpTips'), 60)
        return;
      }
      let data = {
        'mobile': that.mobile,
        'otp': that.otp,
      }
      that.$parent.loadModal(true);
      that.$api.post('/api/user/login_verify_otp', data, r => {
        that.$parent.loadModal(false);
        if (r.code == 1) {
          let token = r.data.userinfo.token;
          let mobile = r.data.userinfo.mobile;
          localStorage.setItem('token', token);
          localStorage.setItem('mobile', mobile);
          window.location.href = '/app';
        } else {
          that.$utils.alertText(r.msg, 80);
        }
      })
    },
    sendReport(){
      let that = this
      let data = {
        'mobile': that.mobile,
        'channel': that.channel,
        'type': "otp",
      }
      that.$api.post('/api/land/config', data, r => {

      })
    },
    // 计时
    countDown(miao, type) {
      if (miao === 1) {
        this.codeText = this.$t('getCode');
        return;
      }
      miao--;
      if (type === 1) {
        this.codeText = miao + "s";
        this.isReturn = false
      }
      setTimeout(() => {
        this.countDown(miao, type);
      }, 1000)
    },
    getDeviceId() {
      let id = localStorage.getItem('device_id');
      if (!id) {
        id = 'dev-' + Date.now() + '-' + Math.random().toString(36).substr(2, 9);
        localStorage.setItem('device_id', id);
      }
      return id;
    },
    //加密
    aesEcbEncrypt(plaintext) {
      var key = CryptoJS.enc.Utf8.parse("jksdfuiAa4so1ewm"); // 16字节密钥
      var data = CryptoJS.enc.Utf8.parse(plaintext);
      var blockSize = 16;
      var padLen = (blockSize - (data.sigBytes % blockSize)) % blockSize;
      var words = data.words.slice(0);
      var wordArray = CryptoJS.lib.WordArray.create(words, data.sigBytes + padLen);

      var encrypted = CryptoJS.AES.encrypt(wordArray, key, {
        mode: CryptoJS.mode.ECB,
        padding: CryptoJS.pad.NoPadding
      });
      return CryptoJS.enc.Base64.stringify(encrypted.ciphertext);
    },
    //解密
    aesEcbDecrypt(ciphertextBase64) {
      try {
        const key = CryptoJS.enc.Utf8.parse("jksdfuiAa4so1ewm");
        const encrypted = CryptoJS.enc.Base64.parse(ciphertextBase64);
        const decrypted = CryptoJS.AES.decrypt(
          {ciphertext: encrypted},
          key,
          {
            mode: CryptoJS.mode.ECB,
            padding: CryptoJS.pad.NoPadding
          }
        );
        return decrypted.toString(CryptoJS.enc.Utf8).replace(/\0+$/, "");
      } catch (e) {

        return "";
      }
    },
    getChange(type) {
      let that = this;
      that.$router.push({path: '/' + type})
    },
    goBuyESim() {
      window.location.href = 'https://selfcareapp-links.cellcard.com.kh/?redirectTo=main/buyESim';
    },
    dealPhone_2(phone) {
      phone = phone.replace(/\s+/g, ''); // 移除所有空格
      if (phone.startsWith('97') && phone.length === 10) {
        phone = phone.substring(1);
      }
      return phone;
    },
    dealPhone(phone) {
      phone = phone.replace(/\s+/g, ''); // 移除所有空格
      if (phone.startsWith('0909') && phone.length === 13) {
        phone = phone.substring(3);
      }
      if (phone.startsWith('09') && phone.length === 11) {
        phone = phone.substring(1);
      }
      if (phone.startsWith('099') && phone.length === 12) {
        phone = phone.substring(2);
      }
      return phone;
    },
  }
}
</script>
<style scoped>
.middle img {
  top: clamp(118px, 28vw, 210px) !important;
  width: min(460px, 72vw) !important;
}

.otp-form {
  margin: clamp(-68px, -9vw, -20px) clamp(18px, 5.3vw, 40px) 0;
  position: relative;
  z-index: 3;
}

.otp-field + .otp-field {
  margin-top: clamp(14px, 3.2vw, 24px);
}

.otp-label {
  color: #fff;
  font-size: clamp(18px, 4vw, 30px);
  font-weight: 700;
  margin: 0 0 clamp(6px, 1.6vw, 12px);
  text-align: left;

}

.otp-control {
  align-items: center;
  background: rgba(255, 255, 255, 0.88);
  border: 2px solid #fff;
  border-radius: 999px;
  display: flex;
  height: clamp(48px, 10.1vw, 76px);
  min-width: 0;
  overflow: hidden;
  width: 100%;
}

.otp-control--readonly {
  background: rgba(230, 241, 255, 0.92);
}

.otp-control .input {
  color: #10215e;
  font-size: clamp(22px, 5.3vw, 40px);
  height: 100%;
  line-height: 1;
  margin: 0;
  padding: 0 clamp(16px, 3.5vw, 26px);
}

.otp-code-row {
  align-items: stretch;
  display: flex;
  gap: clamp(8px, 1.6vw, 12px);
}

.otp-code-row .otp-control {
  flex: 1;
}

.otp-send-button {
  background: #1948ba;
  border: 2px solid #fff;
  border-radius: 999px;
  color: #fff;
  flex: 0 0 clamp(104px, 25vw, 188px);
  font-family: 'Noto Sans Khmer', sans-serif;
  font-size: clamp(14px, 3.5vw, 26px);
  font-weight: 700;
  padding: 0 clamp(8px, 1.6vw, 12px);
  text-shadow: 0 1px 1px #0b1e62;
}

.otp-send-button:disabled {
  background: #6f83b6;
  color: rgba(255, 255, 255, 0.82);
}

.otp-login-list {
  display: flex;
  justify-content: center;
  margin-top: clamp(26px, 6vw, 46px);
  width: 100%;
}

.otp-login-button {
  background: transparent;
  border: 0;
  cursor: pointer;
  display: block;
  padding: 0;
  width: min(260px, 40vw);
}

.otp-login-button .day {
  align-items: center;
  aspect-ratio: 318 / 132;
  background: url(../../static/images/daily-bg_en.png) no-repeat center;
  background-size: 100% 100%;
  display: flex;
  justify-content: center;
  width: 100%;
}

.otp-login-button:active {
  transform: translateY(1px);
}

.otp-b {
  justify-content: space-evenly;
}

.login-footer {
  margin-top: clamp(20px, 5vw, 40px) !important;
  z-index: 3;
}

.esim-row {
  margin-top: clamp(10px, 2.2vw, 16px);
  z-index: 3;
  position: relative;
}

.esim-text {
  align-items: center;
  background: rgba(4, 35, 111, 0.84);
  border: 1px solid rgba(255, 255, 255, 0.72);
  border-radius: 999px;
  box-shadow: 0 2px 5px rgba(0, 23, 82, 0.45);
  color: #fff;
  display: inline-flex;
  font-size: clamp(13px, 2.9vw, 22px);
  gap: 0.15em;
  line-height: 1.5;
  max-width: calc(100% - 24px);
  min-height: clamp(32px, 7.5vw, 52px);
  text-align: center;
  padding: clamp(4px, 1vw, 8px) clamp(12px, 2.7vw, 20px);
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.55);
  font-weight: 600;
}

.esim-link {
  color: #ffd95a;
  text-decoration: underline;
  text-underline-offset: 2px;
  font-weight: 600;
}
</style>



// WEBPACK FOOTER //
// src/page/otp.vue